export const ERROR_REPORTING_TEAM = 'advanced-roadmaps';
export const PACKAGE_NAME = 'jiraPortfolio3PlanIssueStatus';
export const SERVICES_ERROR_ID = 'services';
